export const FormSubtitle = ({ text }: { text: string }) => {
  return <h3 className="text-lg text-center font-semibold leading-7 text-gray-600">{text}</h3>;
};
